import { BaseShaderMaterial } from 'ohzi-core';
import fragment from './BuildingShader.frag'
import vertex from './BuildingShader.vert'
import DatGui from '../components/DatGui';
import { ResourceContainer } from 'ohzi-core';
import { Screen } from 'ohzi-core';
import { Time } from 'ohzi-core';

import { Vector2 } from 'three';
import { Color } from 'three';
import { sRGBEncoding } from 'three';



export default class BuildingMaterial extends BaseShaderMaterial
{
  constructor(material, obj)
  {
    let map = material.map//? material.map : material;

    if (map) {
      map.encoding = sRGBEncoding;
      map.flipY = false;
    }

    super(vertex, fragment, {
      map: {value : map},
      //uGradient: {value : ResourceContainer.get_resource("gradient")},
      uGrid: {value : ResourceContainer.get_resource("grid")},
      //uHeightmap: {value : ResourceContainer.get_resource("heightmap")},
      //uNoise: {value : ResourceContainer.get_resource("noise")},

      color: {value: new Color("#ffffff")},
      uTimer: {value: 0},
      uAlpha: {value: 0},
      lights: true,
      fog: true,
      transparent: true
     }
    );
    this.transparent = true;
    this.extensions.derivatives = true;
  }

  set_alpha(alpha) {
    this.uniforms.uAlpha.value = alpha;
  }

  update() {
    this.uniforms.uTimer.value = (Math.sin(Time.elapsed_time) + 2.0) * 0.2;
    //console.trace(alpha)
    //if(this.uniforms.timer.value !== Time.elapsed_time)
    //  this.uniforms.timer.value = Time.elapsed_time;
    //if(this.uniforms.refractionIndex.value !== DatGui.settings.refractionIndex)
    //  this.uniforms.refractionIndex.value = DatGui.settings.refractionIndex;
    //if(this.uniforms.dispersion.value !== DatGui.settings.dispersion)
    //  this.uniforms.dispersion.value = DatGui.settings.dispersion;
    //if(this.uniforms.roughness.value !== DatGui.settings.roughness)
    //  this.uniforms.roughness.value = DatGui.settings.roughness;
    //if(this.uniforms.opacity.value !== DatGui.settings.opacity)
    //  this.uniforms.opacity.value = DatGui.settings.opacity;
    //if(this.uniforms.fesnel.value !== DatGui.settings.fesnel)
    //  this.uniforms.fesnel.value = DatGui.settings.fesnel;
    //if(this.uniforms.color.value !== DatGui.settings.color)
    //  this.uniforms.color.value.set(DatGui.settings.color);
  }
    
};
